module.exports = __webpack_public_path__ + "static/media/20190402_071222.ec1876ac.jpg";